import axios, { AxiosPromise } from "axios";
import { env } from "../env/env";
import Storage from "../util/Storage";
import { DisplayUploadDto } from "../domain/DisplayUploadDto";
import { DisplayUploadRenameDto } from "../domain/DisplayUploadRenameDto";

export function getQrBasePath() {
  if (window.location.hostname.match("staging.mhmfun.com")) return "https://stage.mhme.nu";
  if (window.location.hostname.match("musthavemenus.com")) return "https://ohbz.com";
  if (window.location.hostname.match("localhost")) return "https://test.mhmfun.com";

  return env.basePath;
}

const QRDisplayUploadsApi = {
  getDisplayUploadsByLocationId(locationId: String): AxiosPromise<DisplayUploadDto[]> {
    return axios.get(
      `${getQrBasePath()}${env.lpContextPath}/api/v1/uploads/dsa/${locationId}/uploads`,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        }
      }
    )
  },
  
  getDisplayUploadsByLocationIds(locationIds: number[]): AxiosPromise<DisplayUploadDto[]> {
    return axios.post(
      `${getQrBasePath()}${env.lpContextPath}/api/v1/uploads/dsa/uploads`,
      locationIds,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        }
      }
    )
  },

  uploadDisplayAppImage(memberId: String, locationId: String, body: FormData): AxiosPromise<DisplayUploadDto> {
    return axios.post(
      `${getQrBasePath()}${env.lpContextPath}/api/v1/uploads/${memberId}/dsa/${locationId}/upload`,
      body,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        }
      }
    )
  },

  updateDisplayUploadName(body: DisplayUploadRenameDto): AxiosPromise<DisplayUploadDto> {
    return axios.post(
      `${getQrBasePath()}${env.lpContextPath}/api/v1/uploads/dsa/name`,
      body,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        }
      }
    )
  },

  deleteDisplayUpload(uploadId: String): AxiosPromise<void> {
    return axios.delete(
      `${getQrBasePath()}${env.lpContextPath}/api/v1/uploads/dsa/${uploadId}`,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        }
      }
    )
  }
};

export default QRDisplayUploadsApi;
